"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.omnimatch = void 0;
var support_1 = require("./support");
var dictionary_match_1 = require("./dictionary_match");
var spatial_match_1 = require("./spatial_match");
var repeat_match_1 = require("./repeat_match");
var sequence_match_1 = require("./sequence_match");
var regex_match_1 = require("./regex_match");
var date_match_1 = require("./date_match");
// ------------------------------------------------------------------------------
// omnimatch -- combine everything ----------------------------------------------
// ------------------------------------------------------------------------------
function omnimatch(password) {
    var matches = [];
    var matchers = [
        dictionary_match_1.dictionary_match,
        dictionary_match_1.reverse_dictionary_match,
        dictionary_match_1.l33t_match,
        spatial_match_1.spatial_match,
        repeat_match_1.repeat_match,
        sequence_match_1.sequence_match,
        regex_match_1.regex_match,
        date_match_1.date_match,
    ];
    for (var _i = 0, matchers_1 = matchers; _i < matchers_1.length; _i++) {
        var matcher = matchers_1[_i];
        matches = __spreadArrays(matches, matcher(password));
    }
    return support_1.sorted(matches);
}
exports.omnimatch = omnimatch;
//# sourceMappingURL=index.js.map